
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {Button, Col, Input, Row, Table} from 'reactstrap'
import { SpinnerComponent } from 'react-element-spinner'
import { v4 as uuidv4 } from 'uuid'
import { library } from "@fortawesome/fontawesome-svg-core"
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(faTrash)

import VehicleInspectionsService from '../../services/VehicleInspectionsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'
import { InspectionsContext } from '../../contexts/InspectionsProvider'
import Enumeration from '../../enumeration'

const Tires = ({ vehicleId = 0, isUserInAdminGroup = false }) =>
{
	const { t } = useTranslation()
	const [isBusy, setIsBusy] = useState(false)
	const sessionContext = useContext(SessionContext)
	const inspectionsContext = useContext(InspectionsContext)
	const [rimTypes, setRimTypes] = useState([])
	const [winterTireOptions, setWinterTireOptions] = useState([])
	const [tireLocations, setTireLocations] = useState([])
	const [vehicleInspectionId, setVehicleInspectionId] = useState('')

	useEffect(() =>
	{
		setRimTypes(['ALLOY', 'OEM ALLOY', 'CHROME', 'COVERS', 'STEEL'])
		setWinterTireOptions([{ value: false, label: 'No' }, { value: true, label: 'Yes' }])
		setTireLocations(['FRONT LEFT TIRE', 'FRONT RIGHT TIRE', 'REAR LEFT TIRE', 'REAR RIGHT TIRE', 'SPARE TIRE'])

		retrieveVehicleInspectionTires()
	}, [])

	const retrieveVehicleInspectionTires = () =>
	{
		setIsBusy(true)
		VehicleInspectionsService
			.getVehicleInspectionTires(vehicleId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				const addOn = { edited: false, new: false }
				const extendedInspectionTires = []
				result.data.actionResult.forEach((inspectionTire) =>
				{
					extendedInspectionTires.push(Object.assign(inspectionTire, addOn))
					setVehicleInspectionId(inspectionTire.vehicleInspectionId)
				})

				inspectionsContext.setVehicleInspectionTires(extendedInspectionTires)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}

	const handleTirePropertyChange = (e, vehicleInspectionTireId) =>
	{
		const { name, value} = e.target
		inspectionsContext.setVehicleInspectionTires((previousTires) =>
		{
			let currentTires = [...previousTires]
			let tireIndex = currentTires.findIndex(tire => tire.vehicleInspectionTireId === vehicleInspectionTireId)
			currentTires[tireIndex][name] = value
			currentTires[tireIndex].edited = true
			return currentTires
		})
	}

	const handleAddNewTire = () =>
	{
		inspectionsContext.setVehicleInspectionTires((previousTires) =>
		{
			let currentTires = [...previousTires]
			currentTires.push({
				vehicleInspectionTireId: uuidv4(),
				tireLocation: '',
				wheelType: 'ALLOY',
				treadDepth: 0,
				winter: 0,
				speedRating: '',
				width: 0,
				aspectRation: 0,
				diameter: 0,
				tireMaker: '',
				new: true
			})
			return currentTires
		})
	}

	const handleRemoveTire = (e, vehicleInspectionTireId) =>
	{
		e.preventDefault()

		inspectionsContext.setVehicleInspectionTires((previousTires) =>
		{
			let currentTires = [...previousTires]
			let tireIndex = currentTires.findIndex(tire => tire.vehicleInspectionTireId === vehicleInspectionTireId)
			currentTires.splice(tireIndex, 1)
			return currentTires
		})
	}

	const handleSaveTires = () =>
	{
		setIsBusy(true)
		VehicleInspectionsService
			.updateVehicleInspectionTires({ vehicleInspectionId: vehicleInspectionId, vehicleInspectionTires: inspectionsContext.vehicleInspectionTires }, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)


			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}

	return (
		<>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
			/>
            {
                SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) &&
                <Row>
                    <Col md="12">
                        <div className="text-right">
                            <Button
                                color="secondary"
                                size="sm"
                                type="button"
                                onClick={ () => handleAddNewTire() }
                            >
                                Add New Tire
                            </Button>
                        </div>
                    </Col>
                </Row>
            }
			<Row>
				<Col md="12">
					<div className="table-responsive" >
						<Table className="align-items-center table-flush">
							<thead className="thead-light">
								<tr>
									<th className="sort" scope="col">{ t('Auctions.Condition.Tire') }</th>
									<th className="sort" scope="col" style={{ width: '250px' }}>{ t('Auctions.Condition.WheelType') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.TreadDepth') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.WinterTire') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.SpeedRating') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.TireWidth') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.AspectRatio') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.TireSize') }</th>
									<th className="sort" scope="col">{ t('Auctions.Condition.Manufacturer') }</th>
									<th className="sort" scope="col"></th>
								</tr>
							</thead>
							<tbody className="list">
								{inspectionsContext.vehicleInspectionTires.map((tire) => (
									<tr key={ tire.vehicleInspectionTireId } style={{ cursor: 'pointer' }} >
										<td>
											<Input
												name="tireLocation"
												type="select"
												className="form-control-sm"
												style={{ width: 'auto' }}
												value={ (tire.tireLocation || '').trim() }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											>
												{
													tireLocations !== undefined &&
													tireLocations.map((tireLocation, idx) => (
														<option value={ tireLocation } key={ idx }>
															{ tireLocation }
														</option>
													))
												}
											</Input>
										</td>
										<td>
											<Input
												name="wheelType"
												type="select"
												className="form-control-sm"
												style={{ width: 'auto' }}
												value={ tire.wheelType }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											>
												{
													rimTypes !== undefined &&
													rimTypes.map((rimType, idx) => (
														<option value={ rimType } key={ idx }>
															{ rimType }
														</option>
													))
												}
											</Input>
										</td>
										<td>
											<Input
												name="treadDepth"
												type="text"
												className="form-control-sm"
												value={ tire.treadDepth }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											/>
										</td>
										<td>
											<Input
												name="winter"
												type="select"
												className="form-control-sm"
												style={{ width: 'auto' }}
												value={ tire.winter }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											>
												{
													winterTireOptions !== undefined &&
													winterTireOptions.map((winterTireOption, idx) => (
														<option value={ winterTireOption.value } key={ idx }>
															{ winterTireOption.label }
														</option>
													))
												}
											</Input>
										</td>
										<td>
											<Input
												name="speedRating"
												type="text"
												className="form-control-sm"
												value={ tire.speedRating }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											/>
										</td>
										<td>
											<Input
												name="width"
												type="text"
												className="form-control-sm"
												value={ tire.width }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											/>
										</td>
										<td>
											<Input
												name="aspectRatio"
												type="text"
												className="form-control-sm"
												value={ tire.aspectRatio }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											/>
										</td>
										<td>
											<Input
												name="diameter"
												type="text"
												className="form-control-sm"
												value={ tire.diameter }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											/>
										</td>
										<td>
											<Input
												name="tireMaker"
												type="text"
												className="form-control-sm"
												value={ tire.tireMaker }
												onChange={ (ev) => { handleTirePropertyChange(ev, tire.vehicleInspectionTireId) } }
                                                disabled={ !SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) }
											/>
										</td>
										<td>
                                            {
                                                SiteService.isInGroup(sessionContext.loginSession, Enumeration.UserGroups.Administrators) &&
												<Button
													className="btn-icon-only rounded-circle"
													color="light"
													title="Create Auction"
													onClick={ (event) => handleRemoveTire(event, tire.vehicleInspectionTireId) }
												>
													<span className="btn-inner--icon">
														<FontAwesomeIcon icon={ faTrash } style={{ color: 'red' }} />
													</span>
												</Button>
                                            }
                                        </td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>
				</Col>
			</Row>
			{
				isUserInAdminGroup &&
				<Row>
					<Col md="12">
						<Button
							block
							color="primary"
							className="btn-block"
							onClick={ handleSaveTires } style={{'marginTop': '20px'}}
						>
							Save Tires
						</Button>
					</Col>
				</Row>
			}
		</>
	)
}

export default Tires
